/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from 'ng2-translate/src/translate.pipe';
import * as import2 from 'ng2-translate/src/translate.service';
import * as import3 from './decimal-field.component';
import * as import4 from '../field/field.component.ngfactory';
import * as import5 from '../field/field.component';
import * as import6 from '../form/form.component';
import * as import7 from '@angular/forms';
import * as import8 from '@angular/common';
const styles_DecimalFieldComponent:any[] = ([] as any[]);
export const RenderType_DecimalFieldComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_DecimalFieldComponent,
  data: {}
}
);
function View_DecimalFieldComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'decimal-field-placeholder'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n            ',
      '\n        '
    ]
    )),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,2).transform(co.placeholder,co.translationParams));
    ck(v,1,0,currVal_0);
  });
}
export function View_DecimalFieldComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵqud(402653184,1,{inputER: 0}),
      (l()(),import0.ɵeld(0,(null as any),(null as any),16,'woa-field',([] as any[]),[[
        2,
        'no-message',
        (null as any)
      ]
      ],[[
        (null as any),
        'onActivateLink'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import3.DecimalFieldComponent = v.component;
      if (('onActivateLink' === en)) {
        const pd_0:any = ((<any>co.onActivateLink.emit()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import4.View_FieldComponent_0,import4.RenderType_FieldComponent)),
    import0.ɵdid(49152,(null as any),1,import5.FieldComponent,[
      [
        2,
        import6.FormComponent
      ]
      ,
      [
        2,
        import7.NgControl
      ]

    ]
    ,{
      label: [
        0,
        'label'
      ]
      ,
      link: [
        1,
        'link'
      ]
      ,
      message: [
        2,
        'message'
      ]
      ,
      translationParams: [
        3,
        'translationParams'
      ]
      ,
      readOnly: [
        4,
        'readOnly'
      ]
      ,
      disabled: [
        5,
        'disabled'
      ]
      ,
      defaultInput: [
        6,
        'defaultInput'
      ]

    }
    ,{onActivateLink: 'onActivateLink'}),
    import0.ɵqud(603979776,2,{models: 1}),
    (l()(),import0.ɵted(0,['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),0,11,'div',[[
        'class',
        'decimal-field'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,[
      [
        1,
        0
      ]
      ,
      [
        'input',
        1
      ]

    ]
    ,(null as any),5,'input',[
      [
        'class',
        'decimal-field-input'
      ]
      ,
      [
        'inputmode',
        'decimal'
      ]
      ,
      [
        'type',
        'text'
      ]

    ]
    ,[
      [
        1,
        'id',
        0
      ]
      ,
      [
        1,
        'autocomplete',
        0
      ]
      ,
      [
        1,
        'maxlength',
        0
      ]
      ,
      [
        1,
        'pattern',
        0
      ]
      ,
      [
        8,
        'readOnly',
        0
      ]
      ,
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'ngModelChange'
      ]
      ,
      [
        (null as any),
        'keydown'
      ]
      ,
      [
        (null as any),
        'keyup'
      ]
      ,
      [
        (null as any),
        'input'
      ]
      ,
      [
        (null as any),
        'blur'
      ]
      ,
      [
        (null as any),
        'compositionstart'
      ]
      ,
      [
        (null as any),
        'compositionend'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:import3.DecimalFieldComponent = v.component;
      if (('input' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,8)._handleInput($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import0.ɵnov(v,8).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('compositionstart' === en)) {
        const pd_2:any = ((<any>import0.ɵnov(v,8)._compositionStart()) !== false);
        ad = (pd_2 && ad);
      }
      if (('compositionend' === en)) {
        const pd_3:any = ((<any>import0.ɵnov(v,8)._compositionEnd($event.target.value)) !== false);
        ad = (pd_3 && ad);
      }
      if (('ngModelChange' === en)) {
        const pd_4:any = ((<any>(co.value = $event)) !== false);
        ad = (pd_4 && ad);
      }
      if (('keydown' === en)) {
        const pd_5:any = ((<any>co.DecimalFieldComponent.validateCharacter($event)) !== false);
        ad = (pd_5 && ad);
      }
      if (('keyup' === en)) {
        const pd_6:any = ((<any>co.DecimalFieldComponent.correctInput($event)) !== false);
        ad = (pd_6 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(16384,(null as any),0,import7.DefaultValueAccessor,[
      import0.Renderer,
      import0.ElementRef,
      [
        2,
        import7.COMPOSITION_BUFFER_MODE
      ]

    ]
    ,(null as any),(null as any)),
    import0.ɵprd(1024,(null as any),import7.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import7.DefaultValueAccessor]),
      import0.ɵdid(671744,[[
        2,
        4
      ]
    ],0,import7.NgModel,[
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import7.NG_VALUE_ACCESSOR
      ]

    ]
      ,{model: [
        0,
        'model'
      ]
    },{update: 'ngModelChange'}),
    import0.ɵprd(2048,(null as any),import7.NgControl,(null as any),[import7.NgModel]),
    import0.ɵdid(16384,(null as any),0,import7.NgControlStatus,[import7.NgControl],(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_DecimalFieldComponent_1)),
    import0.ɵdid(16384,(null as any),0,import8.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted(0,['\n'])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import3.DecimalFieldComponent = v.component;
    const currVal_1:any = co.label;
    const currVal_2:any = co.link;
    const currVal_3:any = co.message;
    const currVal_4:any = co.translationParams;
    const currVal_5:any = co.readOnly;
    const currVal_6:any = co.disabled;
    const currVal_7:any = import0.ɵnov(v,7);
    ck(v,2,0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
    const currVal_20:any = co.value;
    ck(v,10,0,currVal_20);
    const currVal_21:boolean = !co.value;
    ck(v,15,0,currVal_21);
  },(ck,v) => {
    var co:import3.DecimalFieldComponent = v.component;
    const currVal_0:any = import0.ɵnov(v,2).noMessage;
    ck(v,1,0,currVal_0);
    const currVal_8:any = co.inputId;
    const currVal_9:any = co.autocomplete;
    const currVal_10:any = co.maxlength;
    const currVal_11:any = '[0-9]*';
    const currVal_12:any = co.readOnly;
    const currVal_13:any = import0.ɵnov(v,12).ngClassUntouched;
    const currVal_14:any = import0.ɵnov(v,12).ngClassTouched;
    const currVal_15:any = import0.ɵnov(v,12).ngClassPristine;
    const currVal_16:any = import0.ɵnov(v,12).ngClassDirty;
    const currVal_17:any = import0.ɵnov(v,12).ngClassValid;
    const currVal_18:any = import0.ɵnov(v,12).ngClassInvalid;
    const currVal_19:any = import0.ɵnov(v,12).ngClassPending;
    ck(v,7,1,[
      currVal_8,
      currVal_9,
      currVal_10,
      currVal_11,
      currVal_12,
      currVal_13,
      currVal_14,
      currVal_15,
      currVal_16,
      currVal_17,
      currVal_18,
      currVal_19
    ]
    );
  });
}
function View_DecimalFieldComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-decimal-field',([] as any[]),(null as any),(null as any),(null as any),View_DecimalFieldComponent_0,RenderType_DecimalFieldComponent)),
    import0.ɵdid(180224,(null as any),0,import3.DecimalFieldComponent,[import0.ChangeDetectorRef],(null as any),(null as any)),
    import0.ɵprd(5120,(null as any),import7.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import3.DecimalFieldComponent])
  ]
  ,(null as any),(null as any));
}
export const DecimalFieldComponentNgFactory:import0.ComponentFactory<import3.DecimalFieldComponent> = import0.ɵccf('woa-decimal-field',import3.DecimalFieldComponent,View_DecimalFieldComponent_Host_0,{
  inputId: 'inputId',
  label: 'label',
  link: 'link',
  placeholder: 'placeholder',
  message: 'message',
  translationParams: 'translationParams',
  readOnly: 'readOnly',
  disabled: 'disabled',
  value: 'value',
  autocomplete: 'autocomplete',
  maxlength: 'maxlength'
}
,{
  valueChange: 'valueChange',
  onActivateLink: 'onActivateLink'
}
,([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/app/inputs/decimal-field/decimal-field.component.ngfactory.ts